import { Button, Form, Input } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import RegistrationHeader from '../../components/Header/RegistrationHeader';
import useLogin from './useLogin';

import styles from './Login.module.scss';

const Login = () => {
	const { navigateTo, onSubmitLogin } = useLogin();

	const defaultValues = {
		email: '',
		password: '',
	};

	const { control, handleSubmit, formState: { errors } } = useForm({ defaultValues });
	const intl = useIntl();

	return (
		<div className={styles.pageWrapper}>
			<div className={styles.pageContainer}>
				
				<div className={styles.pageContent}>

					<RegistrationHeader
						actionLabel={intl.formatMessage({ id: 'buttons.registration' })}
						onAction={navigateTo.bind(null, '/registration')}
					/>

					<div className={styles.content}>
						<h3><FormattedMessage id="login.title"/></h3>
						<h1><FormattedMessage id="login.subtitle"/></h1>

						<Form onFinish={handleSubmit(onSubmitLogin)}>
							<div className={styles.fieldsContainer}>
								<div className={`${styles.registrationInput} ${styles.fullWidth} ${errors.email ? styles.error : ''}`}>
									<label><FormattedMessage id="formLabels.email" /></label>
									<Controller
										name="email"
										control={control}
										rules={{
											required: intl.formatMessage({ id: 'formErrors.email.required' }),
										}}
										render={({ field: { ref, ...rest } }) => (
											<Input
												{...rest}
												bordered={false}
												className={errors.email && 'error'}
												placeholder="Your email"
											/>
										)}
									/>
									{errors.email?.type === "required" && <div className={styles.errorMessage}>{errors.email?.message}</div>}
									{errors.email?.type === "pattern" && <div className={styles.errorMessage}><FormattedMessage id="formErrors.email.pattern"/></div>}
								</div>

								<div className={`${styles.registrationInput} ${styles.fullWidth} ${errors.password ? styles.error : ''}`}>
									<label><FormattedMessage id="formLabels.password" /></label>
									<Controller
										name="password"
										control={control}
										rules={{ required: intl.formatMessage({ id: 'formErrors.password.required' }) }}
										render={({ field: { ref, ...rest } }) => (
											<Input.Password
												{...rest}
												bordered={false}
												className={errors.password && 'error'}
												placeholder="Your password"
											/>
										)}
									/>
								{errors.password && <div className={styles.errorMessage}>{errors.password?.message}</div>}
								</div>
							</div>

							<div className={styles.buttonsContainer}>
								<Button
									htmlType="submit"
									size="large"
									type="primary"
								>	
									<FormattedMessage id="buttons.enterAccount" />
								</Button>
							</div>
						</Form>
					</div>

					<div className={styles.footer}>
						<Button type="link" onClick={navigateTo.bind(null, '/forgot-password')}>
							<FormattedMessage id="buttons.forgotPassword" />
						</Button>
					</div>
				</div>
				
				<div className={styles.pageSider}></div>
			</div>

		</div>
	);
};

export default Login;